import * as React from 'react';
import { __ } from 'react-i18n';
import styled from 'styled-components';
import { rem } from 'polished';
import { InfoText, InfoType } from '../../General/InfoText';
import {
  FlexCol,
  FlexRowCenterVertical,
  FlexRowCenter,
} from '../../../Defaults/Flexbox/Flexbox';
import { TextP } from '../../../Defaults/Text';
import {
  Button,
  ButtonLink,
  ButtonPrimary,
  ButtonFourthLink,
} from '../../General/Button';
import { ImitradeSummaryValue as SummaryValue } from './ImitradeSummaryValue';
import { AcceptTermsCheckbox } from './AcceptTermsCheckbox';
import { ImitradeFinalValue as FinalValue } from './ImitradeFinalValue';
import { getCartSummaryInfo } from '../../../../utilities/selectors';
import { formatPriceToString, prop } from '../../../../utilities';
import { getSanitasCartSummaryInfo } from '../../selectors';
import { FreeDeliveryBox } from './FreeDeliveryBox';
import { TrustPointComponent } from './TrustPointComponent';
import { AcceptNewsLetterCheckbox } from './AcceptNewsLetterCheckbox';
import { AccepHeurekaCheckbox } from './AcceptHeurekaCheckbox';

interface Props {
  handleStepChange: (step: number) => void;
  data: any;
  handleAcceptTermsChange: (e: any) => void;
  handleAcceptNewsLetterChange: (e: any) => void;
  handleAcceptHeurekaChange: (e: any) => void;
  handlePointsChange: (points: any) => void;
  isFetching: boolean;
  freeDel: number | null;
  user: any;
  pointsAmountRatio?: number;
}

function ThirdStep({
  handleStepChange,
  data,
  handleAcceptTermsChange,
  handleAcceptNewsLetterChange,
  handleAcceptHeurekaChange,
  handlePointsChange,
  isFetching,
  freeDel,
  user,
  pointsAmountRatio,
}: Props) {
  const {
    totalPrice,
    totalPriceWithoutVat,
    vatTotal,
    currency,
    deliveryPrice,
    paymentPrice,
    totalItemsPrice,
    totalItemsPriceWithoutVat,
    priceRoundingValue,
  } = getCartSummaryInfo(data);
  const {
    vatGroup0Total,
    vatGroup0TotalWithDph,
    vatGroup20Total,
    vatGroup20TotalDph,
    vatGroup20TotalWithDph,
  } = getSanitasCartSummaryInfo(data);
  const termsAccept = prop(data, 'terms_accept');
  const newsLetterAccept = prop(data, 'newsletter_accept');
  const heurekaAccept = prop(data, 'heureka');
  const canOrder =
    termsAccept && prop(data, 'delivery') && prop(data, 'payment');
  const { items, consumed_points } = data;
  const hasNullPriceItems = items.some(i => i.sum_price === 0);

  return (
    <>
      <DesktopFields>
        <SummaryValue
          title={__('Cena tovaru bez DPH')}
          value={formatPriceToString(totalItemsPriceWithoutVat, currency)}
        />
        {false && (
          <SummaryValue
            title={__('Vernostná zľava 2 %')}
            value={formatPriceToString(1, currency)}
          />
        )}
        <SummaryValue
          borderBottom={false}
          title={__('Doprava s DPH')}
          value={formatPriceToString(deliveryPrice, currency)}
        />
        <SummaryValue
          borderBottom={false}
          title={__('Platba s DPH')}
          value={formatPriceToString(paymentPrice, currency)}
        />
        {priceRoundingValue > 0 || priceRoundingValue < 0 ? (
          <SummaryValue
            borderBottom={false}
            title={__('Zaokrúhlenie')}
            value={formatPriceToString(priceRoundingValue, currency)}
          />
        ) : null}

        {/* {vatGroup20TotalDph && (
          <>
            {' '}
            <SummaryValue
              title={__('Základ dane pre 20 %')}
              value={formatPriceToString(vatGroup20Total, currency)}
            />
            <SummaryValue
              title={__('DPH 20 %')}
              value={formatPriceToString(vatGroup20TotalDph, currency)}
            />
            <SummaryValue
              borderBottom={true}
              title={__('Cena s DPH')}
              value={formatPriceToString(vatGroup20TotalWithDph, currency)}
            />
          </>
        )} */}
        {/* {vatGroup0TotalWithDph && (
          <>
            {' '}
            <SummaryValue
              title={__('Základ dane pre 0 %')}
              value={formatPriceToString(vatGroup0Total, currency)}
            />
            <SummaryValue
              title={__('DPH 0 %')}
              value={formatPriceToString('0.00', currency)}
            />
            <SummaryValue
              borderBottom={true}
              title={__('Cena s DPH')}
              value={formatPriceToString(vatGroup0TotalWithDph, currency)}
            />
          </>
        )} */}
        <FreeDeliveryBox value={freeDel} currency={currency} />
        {user && prop(user, 'trust_points') > 0 ? (
          <TrustPointComponent
            handlePointsChange={handlePointsChange}
            user={user}
            cartPrice={totalItemsPrice}
            currency={currency}
            consumedPoints={consumed_points}
            pointsAmountRatio={pointsAmountRatio}
          />
        ) : null}

        <FinalValue
          title={__('Celkom k úhrade s DPH')}
          value={formatPriceToString(totalPrice, currency)}
        />
      </DesktopFields>
      <MobileFields>
        <SummaryValue
          title={__('Cena bez DPH')}
          value={formatPriceToString(totalPriceWithoutVat, currency)}
        />
        <SummaryValue
          title={__('DPH 20 %')}
          value={formatPriceToString(vatTotal, currency)}
        />
        <SummaryValue
          title={__('Cena s DPH')}
          value={formatPriceToString(totalPrice, currency)}
        />
        <SummaryValue
          borderBottom={false}
          title={__('Doprava s DPH')}
          value={formatPriceToString(deliveryPrice, currency)}
        />
        <SummaryValue
          borderBottom={false}
          title={__('Platba s DPH')}
          value={formatPriceToString(paymentPrice, currency)}
        />
        <FreeDeliveryBox value={freeDel} currency={currency} />
        {user && prop(user, 'trust_points') > 0 ? (
          <TrustPointComponent
            handlePointsChange={handlePointsChange}
            cartPrice={totalItemsPrice}
            user={user}
            currency={currency}
            consumedPoints={consumed_points}
            pointsAmountRatio={pointsAmountRatio}
          />
        ) : null}
        <FinalValue
          title={__('Celkom k úhrade s DPH')}
          value={formatPriceToString(totalPrice, currency)}
        />
      </MobileFields>
      <Wrapper>
        <AcceptTermsCheckbox
          name="acceptTerms"
          onClick={handleAcceptTermsChange}
          selected={termsAccept}
        />
        <AcceptNewsLetterCheckbox
          name="newsLetterAccept"
          onClick={handleAcceptNewsLetterChange}
          selected={newsLetterAccept}
        />
        <AccepHeurekaCheckbox
          name="heurekaAccept"
          onClick={handleAcceptHeurekaChange}
          selected={heurekaAccept}
        />
      </Wrapper>
      <NextButton
        disabled={!canOrder || isFetching}
        // tslint:disable-next-line:jsx-no-lambda
        onClick={() => handleStepChange(4)}
      >
        {isFetching ? (
          <FlexRowCenter>
            <Loader className="marginLeft" small={true} />
          </FlexRowCenter>
        ) : (
          __('Objednávka s povinnosťou platby')
        )}
      </NextButton>
      <BackButton
        // tslint:disable-next-line:jsx-no-lambda
        onClick={() => handleStepChange(2)}
      >
        {__('Späť')}
      </BackButton>
    </>
  );
}

export const Loader = styled.div<{ className?: string; small?: boolean }>`
  width: ${({ small }) => (small ? rem(20) : rem(50))};
  height: ${({ small }) => (small ? rem(20) : rem(50))};
  border: ${({ small }) =>
    small ? `${rem(4)} solid #f9f9f9` : `${rem(10)} solid #f9f9f9`};
  border-top: ${({ small, theme }) =>
    small
      ? `${rem(4)} solid ${theme.blogColors.primary}`
      : `${rem(10)} solid ${theme.blogColors.primary}`};
  margin: 0;
  border-radius: 50%;
  animation: spin 1.5s linear infinite;

  @keyframes spin {
    0% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(360deg);
    }
  }
`;

const Wrapper = styled(FlexCol)`
  width: 100%;
  max-width: ${rem(428)};
  margin-top: ${rem(15)};
  margin-bottom: ${rem(20)};
`;

const NextButton = styled(ButtonPrimary)`
  width: 100%;
  max-width: ${rem(328)};
  margin: 0 0 ${rem(16)};
`;

const BackButton = styled(ButtonFourthLink)`
  max-width: ${rem(328)};
`;

const DesktopFields = styled(FlexCol)`
  ${({ theme }) => theme.mediab.l925`
    display: none;
  `}
`;

const MobileFields = styled(FlexCol)`
  display: none;
  margin-bottom: ${rem(16)};

  ${({ theme }) => theme.mediab.l925`
    display: flex;
  `}
`;

export { ThirdStep };
